// eslint-disable-next-line no-restricted-imports
import {
  AccountAccountCategoryEnum,
  AccountAccountProxyTypeEnum,
  Account as IAccount,
} from '@eih-netbroker/api-account';
import { Loadable, LoadableState } from '../../utils';
import { atomWithBroadcast } from '../core/atomWithBroadcast';

export const AccountCategory = AccountAccountCategoryEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AccountCategory = (typeof AccountCategory)[keyof typeof AccountCategory];

export const AccountProxyType = AccountAccountProxyTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AccountProxyType = (typeof AccountProxyType)[keyof typeof AccountProxyType];

export type Account = IAccount;

export type Client = {
  clientId: string;
  accounts: Array<Account>;
  clientName: string;
};

export type Accounts = {
  clients: Array<Client>;
};

export const accountsAtom = atomWithBroadcast<LoadableState<Accounts>>('core/accounts', Loadable.uninitialized);
